import DOMPurify from "dompurify";

/**
 * Sanitize HTML coming from Airtable (admin-curated dealer/product content)
 * before passing it to `dangerouslySetInnerHTML`.
 *
 * Content authors are trusted (admins editing OreVital base via Airtable),
 * but defense-in-depth — strips <script>, on* handlers, javascript: URLs,
 * and other XSS vectors so a compromised row can't pop scripts on the
 * public dealer page.
 */
export function sanitizeHtml(raw) {
  if (!raw) return "";
  return DOMPurify.sanitize(String(raw), {
    USE_PROFILES: { html: true },
    // Allow embedded YouTube / video iframes used in product widgets but
    // still block scripts.
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["target", "rel", "allow", "allowfullscreen", "frameborder"],
    FORBID_TAGS: ["script", "style"],
    FORBID_ATTR: ["onerror", "onload", "onclick", "onmouseover"],
  });
}
